export default "__VITE_ASSET__pt29U8zo__"